import { get } from '../../../utils/api';

export default {
  getSailplayGifts: () => get({ url: 'sailplay/gifts' }),
};
